import React from 'react';

import { SciPage, SciTemplate } from 'enums';
import { DefaultHelpPage, SqHelpPage } from 'pages/Help';
import { DefaultNotFoundPage, SqNotFoundPage } from 'pages/NotFound';
import { PageLayoutViewProps, PaymentLoadingViewProps } from 'types';
import {
  DefaultOrderView,
  DefaultPageLayoutView,
} from 'views/DefaultOrderView';
import { DefaultPaymentLoading } from 'views/DefaultOrderView/components';
import {
  RosaOneOrderView,
  RosaOnePageLayoutView,
} from 'views/RosaOneOrderView';
import { RosaOnePaymentLoading } from 'views/RosaOneOrderView/components';
import { SberQrOrderView, SberQrPageLayoutView } from 'views/SberQrOrderView';
import { SberQrPaymentLoading } from 'views/SberQrOrderView/components';
import { SqOrderView, SqPageLayoutView } from 'views/SqOrderView';
import { SqPaymentLoading } from 'views/SqOrderView/components';

export const ORDER_VIEW_REGISTRY: Record<SciTemplate, React.ComponentType> = {
  [SciTemplate.Default]: DefaultOrderView,
  [SciTemplate.SQ]: SqOrderView,
  [SciTemplate.SberQr]: SberQrOrderView,
  [SciTemplate.RosaOne]: RosaOneOrderView,
};

export const PAGE_LAYOUT_VIEW_REGISTRY: Record<
  SciTemplate,
  React.ComponentType<PageLayoutViewProps>
> = {
  [SciTemplate.Default]: DefaultPageLayoutView,
  [SciTemplate.SQ]: SqPageLayoutView,
  [SciTemplate.SberQr]: SberQrPageLayoutView,
  [SciTemplate.RosaOne]: RosaOnePageLayoutView,
};

export const PAYMENT_LOADING_VIEW_REGISTRY: Record<
  SciTemplate,
  React.ComponentType<PaymentLoadingViewProps>
> = {
  [SciTemplate.Default]: DefaultPaymentLoading,
  [SciTemplate.SQ]: SqPaymentLoading,
  [SciTemplate.SberQr]: SberQrPaymentLoading,
  [SciTemplate.RosaOne]: RosaOnePaymentLoading,
};

export const NOT_FOUND_VIEW_REGISTRY: Record<SciTemplate, React.ComponentType> =
  {
    [SciTemplate.Default]: DefaultNotFoundPage,
    [SciTemplate.SQ]: SqNotFoundPage,
    [SciTemplate.SberQr]: DefaultNotFoundPage,
    [SciTemplate.RosaOne]: DefaultNotFoundPage,
  };

export const HELP_VIEW_REGISTRY: Record<SciTemplate, React.ComponentType> = {
  [SciTemplate.Default]: DefaultHelpPage,
  [SciTemplate.SQ]: SqHelpPage,
  [SciTemplate.SberQr]: DefaultHelpPage,
  [SciTemplate.RosaOne]: DefaultHelpPage,
};

export const PAGE_REGISTRIES: Record<
  SciPage,
  Record<SciTemplate, React.ComponentType<any>>
> = {
  [SciPage.Order]: ORDER_VIEW_REGISTRY,
  [SciPage.PageLayout]: PAGE_LAYOUT_VIEW_REGISTRY,
  [SciPage.PaymentLoading]: PAYMENT_LOADING_VIEW_REGISTRY,
  [SciPage.NotFound]: NOT_FOUND_VIEW_REGISTRY,
  [SciPage.Help]: HELP_VIEW_REGISTRY,
};
